import { User } from '@src/entities/User/ui/components/User';
import { Button as ButtonComponent } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import React, { useState } from 'react';

import { Modal } from '../Modal';

/**
 * Button: Deactivate
 *
 * This button is used to deactivate the selected version of the entity.
 *
 * @param activatedVersion
 * @param currentEntity
 * @param form
 * @param refetch
 * @param setFocusedEntity
 * @param setShowAll
 * @returns {Element}
 * @constructor
 */
export function Button({
  activatedVersion = {},
  currentEntity = {},
  form = {},
  refetch = () => {},
  setFocusedEntity = () => {},
  setShowAll = () => {},
}) {
  const [isOpen, setIsOpen] = useState(false);

  const selectedVersionValue = form?.watch('version');

  return (
    <ErrorHandler location="src/features/CommonCriteria/Deactivate/components/Button/Button.jsx">
      <User.Capability attributes={['deactivate']} resource="Admin:CommonCriteria">
        <ButtonComponent
          isDisabled={activatedVersion?.version !== selectedVersionValue}
          onClick={() => {
            setIsOpen(true);
          }}
          variant="destructive"
        >
          Deactivate
        </ButtonComponent>
      </User.Capability>
      {isOpen && (
        <Modal
          currentEntity={currentEntity}
          isOpen={isOpen}
          refetch={refetch}
          setFocusedEntity={setFocusedEntity}
          setIsOpen={setIsOpen}
          setShowAll={setShowAll}
        />
      )}
    </ErrorHandler>
  );
}
